import { Inject, Injectable, Injector } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import {FuncionesExterno} from "../../externo/funciones-Externo";
import {HttpClient} from "@angular/common/http";

@Injectable({
  providedIn: 'root'
})
export class UsuarioService
{
  constructor(private authService: MsalService, private http: HttpClient){}

  getNombreCuenta(): string
  {
    /*
      SUPONIENDO QUE EL NOMBRE DEL USUARIO SEA :
      EJ:
        100003@ralarsa.com
      Cogeremos el cacho de antes de la arroba
    */
      if (localStorage.getItem("accessToken") != null){

          FuncionesExterno.getDataUser(localStorage.getItem("accessToken")!.toString(), this.http)
              .then((response: any) => {

                  return response.userPrincipalName.split("@")[0].toString();
              });
      }else {
          let username: string = this.authService.instance.getActiveAccount()!.username;
          try {
              return username.split("@")[0];
          } catch (error) {
              return "¿?";
          }
      }

      return "";
  }
}
